<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('classTeaching.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('classTeaching.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-4">
            <a-range-picker
              style="width: 300px"
              format="DD-MM-YYYY"
              :defaultValue="rangeDate"
              :defaultPickerValue="rangeDate"
              @change="dateRangeChange"
            >
              <template slot="renderExtraFooter"></template>
            </a-range-picker>
          </div>
          <div class="col-sm-12 col-md-4 d-flex justify-content-end">
            <treeselect
              :load-options="loadSubProgram"
              :multiple="true"
              :limit="1"
              :options="subProgramOptions"
              :placeholder="$t('all')"
              v-model="model.acps_id"
            />
          </div>
          <div class="ts-flex-grow"></div>
          <select class="form-control" style="width: 120px" v-model="status_id">
            <option value="All">
              {{ $t('all') }}
            </option>
            <option
              v-for="(s, index) in studentStatus"
              :key="index"
              :value="s.status_id"
            >
              {{ s.status }}
            </option>
          </select>
          <div class="col-sm-12 col-md-2 d-flex justify-content-end">
            <ts-input v-model="search" :placeholder="$t('search')" />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <div id="table-container">
          <ts-table
            :records="resources"
            :columns="columns"
            :loading="loading"
            :rowGroup="{
              field: 'sub_program'
            }"
          >
            <template v-slot="{ record }">
              <td class="ts-whitespace-no-wrap">
                {{ record.branch_name }}
              </td>
              <td class="ts-whitespace-no-wrap">
                {{ record.teacher }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.start }}
              </td>
              <td class="ts-whitespace-no-wrap">
                {{ record.subject }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.room }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.time }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ total(record) }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.paid }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.new_student }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.old_student }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.not_paid }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.status }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                <a
                  href="#"
                  v-tooltip="$t('view')"
                  class="mr-2 text-info"
                  @click.prevent="view(record)"
                >
                  <i class="fas fa-eye"></i>
                </a>
                <a
                  href="#"
                  v-tooltip="$t('pdf')"
                  class="mr-2 text-red"
                  @click.prevent="pdf(record)"
                >
                  <i class="fas fa-file-pdf"></i>
                </a>
                <a
                  href="#"
                  v-tooltip="$t('excel')"
                  class="mr-2 text-green"
                  @click.prevent="excel(record)"
                >
                  <i class="fas fa-file-excel"></i>
                </a>
              </td>
            </template>
            <template v-slot:tfooter>
              <tr>
                <td colspan="6" class="ts-text-right ts-font-extrabold">
                  {{ $t('classTeaching.total') }}
                </td>
                <td class="ts-text-center ts-font-extrabold ts-text-red-700">
                  {{ sum(['new_student', 'old_student']) }}
                </td>
                <td class="ts-text-center ts-font-extrabold ts-text-red-700">
                  {{ sum('paid') }}
                </td>
                <td class="ts-text-center ts-font-extrabold ts-text-red-700">
                  {{ sum('new_student') }}
                </td>
                <td class="ts-text-center ts-font-extrabold ts-text-red-700">
                  {{ sum('old_student') }}
                </td>
                <td class="ts-text-center ts-font-extrabold ts-text-red-700">
                  {{ sum('not_paid') }}
                </td>
                <td></td>
              </tr>
            </template>
          </ts-table>
        </div>
        <div class="d-flex justify-content-between align-items-center p-15">
          
          <ts-pagination
            v-model="pagination"
            @navigate="fetchData"
          ></ts-pagination>
        </div>
        <a-drawer
          :title="$t('filter')"
          placement="right"
          :closable="false"
          :visible="visible"
          @close="() => (visible = false)"
          :zIndex="1020"
          width="300px"
        >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <ts-branch-filter @filter="value => (branch_id = value)" />
              </div>
            </div>
          </div>
        </a-drawer>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import { debounce } from 'lodash'
import DetailsComponent from './details'
import ChooseStatus from './choose-status'
import ExcelExport from './excel-export.vue'

export default {
  name: 'classTeaching',
  data() {
    return {
      loading: false,
      model: {
        acps_id: []
      },
      rangeDate: [moment(), moment()],
      branch_id: [],
      visible: false,
      subProgramOptions: null,
      errors: new Errors()
    }
  },
  computed: {
    ...mapState('classTeaching', ['resources', 'pagination', 'studentStatus']),
    search: {
      get() {
        return this.$store.state.classTeaching.search
      },
      set(newVal) {
        this.$store.commit('classTeaching/SET_SEARCH', newVal)
        this.$store.commit('classTeaching/RESET_CURRENT_PAGE')
      }
    },
    status_id: {
      get() {
        return this.$store.state.classTeaching.status_id
      },
      set(newValue) {
        this.$store.commit('classTeaching/SET_STATUS_ID', newValue)
      }
    },
    date_from: {
      get() {
        return this.$store.state.classTeaching.date_from
      }
    },
    date_to: {
      get() {
        return this.$store.state.classTeaching.date_to
      }
    },
    columns() {
      return [
        { name: this.$t('classTeaching.branch') },
        { name: this.$t('classTeaching.teacherName') },
        { name: this.$t('classTeaching.start'), style: 'text-align:center;' },
        { name: this.$t('classTeaching.subject') },
        { name: this.$t('classTeaching.room'), style: 'text-align:center;' },
        { name: this.$t('classTeaching.time'), style: 'text-align:center;' },
        { name: this.$t('classTeaching.total'), style: 'text-align:center;' },
        { name: this.$t('classTeaching.paid'), style: 'text-align:center;' },
        {
          name: this.$t('classTeaching.newStudent'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('classTeaching.oldStudent'),
          style: 'text-align:center;'
        },
        { name: this.$t('classTeaching.notPaid'), style: 'text-align:center;' },
        { name: this.$t('classTeaching.status'), style: 'text-align:center;' },
        { name: this.$t('actions'), style: 'text-align:center; width: 7%;' }
      ]
    },
    sum: vm => column => {
      if (_.isArray(column)) {
        return _.round(
          _.sumBy(vm.resources, function(o) {
            var sumValue = 0
            column.forEach(index => {
              sumValue += o[index]
            })
            return sumValue
          }),
          2
        )
      }
      return _.round(_.sumBy(vm.resources, column), 2)
    }
  },
  created() {
    this.fetchResourceBeforeCreate()
    this.fetchData()
  },
  methods: {
    ...mapActions('classTeaching', ['getSubProgram']),
    fetchResourceBeforeCreate() {
      this.$store
        .dispatch('classTeaching/getStudentStatus')
        .then(() => {})
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    async loadSubProgram({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        this.subProgramOptions = null
        await this.getSubProgram()
          .then(response => {
            this.subProgramOptions = response.data.map(el => ({
              id: el.acps_id,
              label: el.acps_name_foreign
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    },
    total(record) {
      return parseInt(record.new_student) + parseInt(record.old_student)
    },
    fetchData(attributes) {
      this.loading = true
      this.errors = new Errors()
      this.$store
        .dispatch(
          'classTeaching/fetchClassTeaching',
          Object.assign(
            {},
            this.model,
            { branch_id: this.branch_id },
            attributes
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    view(data) {
      this.$modal.show(
        DetailsComponent,
        {
          data: data
        },
        {
          height: 'auto',
          width: '60%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    pdf(data) {
      this.$modal.show(
        ChooseStatus,
        {
          record: data
        },
        {
          height: 'auto',
          width: '300px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    excel(data) {
      this.$modal.show(
        ExcelExport,
        {
          record: data
        },
        {
          height: 'auto',
          width: '300px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    dateRangeChange(dateRange) {
      this.$store.commit(
        'classTeaching/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'classTeaching/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
    }
  },
  watch: {
    'model.acps_id': function(value) {
      if (value) {
        this.fetchData({ acps_id: value })
      }
    },
    status_id: debounce(function(status_id) {
      this.fetchData({
        status_id,
        search: this.search,
        branch_id: this.branch_id
      })
    }, 500),
    branch_id: debounce(function(value) {
      this.fetchData({ branch_id: value })
    }, 500),
    date_from: debounce(function() {
      this.fetchData()
    }, 500),
    date_to: debounce(function() {
      this.fetchData()
    }, 500),
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
#table-container {
  min-height: 60vh;
  overflow-y: scroll;
}

table > tbody > tr td {
  vertical-align: middle;
}

.table > thead > tr > th {
  border: 1px solid #b6c2c9;
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
